import { types, IDatafile, DatafileActionsType } from '../types/datafile'

export const initialState: IDatafile = {
  isLoading: false,
}

export const datafile = (
  state = initialState,
  action: DatafileActionsType
): IDatafile => {
  switch (action.type) {
    case types.CREATE_DATAFILE__STARTED:
    case types.GET_DATAFILE__STARTED:
      return {
        ...state,
        isLoading: true,
        datastream: undefined,
        dataStreamError: undefined,
      }
    case types.CREATE_DATAFILE__SUCCESS:
      return {
        ...state,
        isLoading: false,
      }
    case types.GET_DATAFILE__SUCCESS:
      return {
        ...state,
        isLoading: false,
        datastream: action.datastream,
      }
    case types.CREATE_DATAFILE__FAILURE:
      return {
        ...state,
        isLoading: false,
      }
    case types.GET_DATAFILE__FAILURE:
      return {
        ...state,
        isLoading: false,
        dataStreamError: action.dataStreamError,
      }
    default:
      return state
  }
}
